import numeral from 'numeral'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { animateScroll } from 'react-scroll'

import {
  acceptSecci,
  customerUpdate,
  finanziamentoSelected,
  getComuni,
  getDefaultFinancements,
  getFinancementDetails,
  getNazioni,
  getOrdine,
  newComuni,
  newDefaultFinancements,
  newDefaultFinancementsFindomestic,
  newNazioni,
  newOrdine,
  newSecci,
  paymentMethodSelected,
  phaseChange,
  postBonificoSelected,
  postCompassCustomCalc,
  postFinanziamentoSelected,
  postSecci,
  pricingUpdate,
  reroute,
  storeDumpItForce,
  updateFinancements,
  updateFinancementsCompassCustomCalc,
  updateFinancementsFindomesticCustomCalc,
  updateOrdine,
  updateSecci,
} from '../../../actions/Buy'
import {
  putClienti,
  putClientiCallback,
  tracciatoSent,
} from '../../../actions/buy/Clienti'
import {
  getTabelleDominioCompass,
  getTabelleDominioCompassCallbackCittadinanza,
} from '../../../actions/buy/Compass'
import { setCompassCalcolatriceLogistica } from '../../../actions/buy/Logistica'
import { PAYMENT_METHODS } from '../../../constants/payments'
import { BankTransferSettingsHelper } from '../../../helpers/bankTransfer/settings'
import { FinancingSettingsHelper } from '../../../helpers/financing/settings'
import verify from '../../../modules/verify'
import { enhancedEcommerceTracker } from '../../../tracking/EnhancedEcommerce/tracker'
import FenancementDetails from '../../dumb/FenancementDetails'
import FenancementDetailsFindomestic from '../../dumb/FenancementDetailsFindomestic'
import OrderRecoveryBanner from '../../dumb/OrderRecoveryBanner'
import PdfViewer from '../../PdfViewer'
import BuyCustomCalc from '../dumb/BuyCustomCalc'
import BuyDateInput from '../dumb/BuyDateInput'
import BuyRadioInput from '../dumb/BuyRadioInput'
import BuyRateBox from '../dumb/BuyRateBox'
import BuySelectInput2 from '../dumb/BuySelectInput2'
import {
  filesBaseUrl,
  isFindomestic,
  totaleOrdineEqualTotaleFinanziamento,
} from '../utils'

// load a language
numeral.language('it', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't',
  },

  currency: {
    symbol: '€',
  },
})
numeral.language('it')
numeral.defaultFormat('$ 0,0[.]00')

class Checkout extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.handleModal = this.handleModal.bind(this)
    this.handleDoCustomCalc = this.handleDoCustomCalc.bind(this)
    this.handleRichiediFinanziamento =
      this.handleRichiediFinanziamento.bind(this)
    this.handlePaymentMethod = this.handlePaymentMethod.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.handlePreSecci = this.handlePreSecci.bind(this)
    this.handleAcceptSecci = this.handleAcceptSecci.bind(this)
    this.handleModificaRata = this.handleModificaRata.bind(this)
    this.postSecci = this.postSecci.bind(this)
    this.validate = this.validate.bind(this)
    this.against_map = this.against_map.bind(this)
    this.validate_presecci = this.validate_presecci.bind(this)
    this.buildRateBoxes = this.buildRateBoxes.bind(this)
    this.state.toTop = false
    this.state.customCalc = false
    this.state.customCalcMobile = false
    this.state.modalFile = null
    this.state.loadingFinancements = false
    this.state.loadingCustomCalc = false
    this.state.loadedSecci = false
    this.state.id_finanziamento = null
    this.state.hovered_calcolatrice = null
    this.state.secci_loading = false
    this.state.presecci_nome_error = ''
    this.state.presecci_cognome_error = ''
    this.state.presecci_comune_nascita_error = ''
    this.state.presecci_sesso_error = 'genere'
    this.state.presecci_codice_fiscale_error = ''
    this.state.presecci_data_di_nascita_error = ''
    this.state.custom_calc_rata_mensile_desiderata_error = ''
    this.state.custom_calc_quota_da_finanziare_error = ''

    this.state.bankTransferSettingsHelper = new BankTransferSettingsHelper(
      props.ui.sellout_settings_acquista &&
        props.ui.sellout_settings_acquista.bonifico_settings,
      props.ordine
    )

    this.state.financingSettingsHelper = new FinancingSettingsHelper(
      props.ui.sellout_settings_acquista?.finanziamento_settings
    )
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register', true)
    }
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 20 })
    if (!this.state.toTop) {
      animateScroll.scrollToTop()
      this.setState({ toTop: true })
    }

    this.isOnlyQuotationMode =
      this.state.financingSettingsHelper?.isFinancingOnlyQuotation

    if (this.isOnlyQuotationMode) {
      const uri = `${window.brumbrum.url_api}/findomestic/t/v1/piani-rimborso/${
        this.props.ordine.id_ordine
      }/piano-rimborso/${
        this.props.ordine.id_finanziamento
      }?v=${new Date().getTime()}`

      this.props.getFinancementDetails({
        callback: this.props.updateFinancementsFindomesticCustomCalc,
        uri,
        method: 'GET',
        suppressOnlyErrorNotice: true,
      })
    }

    if (
      !('comune' in this.props.comuni) ||
      this.props.comuni.comune === null ||
      this.props.comuni.comune.length === 0
    ) {
      this.props
        .getComuni({
          uri: `${window.brumbrum.url_api}/comuni/p/v1/list/comune`,
          method: 'GET',
          callback: this.props.newComuni,
        })
        .catch(() => null)
    }

    if (
      !('nazione' in this.props.comuni) ||
      this.props.comuni.nazione === null ||
      this.props.comuni.nazione.length === 0
    ) {
      this.props
        .getNazioni({
          uri: `${window.brumbrum.url_api}/comuni/p/v1/list/nazioni/complete/all`,
          method: 'GET',
          callback: this.props.newNazioni,
        })
        .catch(() => null)
    }

    /**
     * BRUM-2887 PROCESSO D'ACQUISTO: uniformare checkout a pagina prodotto
     * state.pricing.total contiene un totale calcolato prima di piazzare l'ordine in Cart.jsL65 (prezzo_sellout+passaggio)
     * qui avendo gia' l'ordine possiamo recuperare il totale che c'e' in backend
     * cosi' da essere sicuri di mostrare il valore corretto durante il processo d'acquisto
     */
    if ('id_ordine' in this.props.ordine && this.props.ordine.id_ordine) {
      // nel caso di refresh id_ordine e' vuoto e non devo tentare la chiamata
      this.props.setCompassCalcolatriceLogistica({
        modal_new_rate_logistica: true,
      })
      this.props
        .getOrdine({
          callback: this.props.newOrdine,
          method: 'GET',
          token: this.props.customer.token,
          uri: `${window.brumbrum.url_api}/ordini/t/v1/ordini/${this.props.ordine.id_ordine}`,
        })
        .then(json => {
          this.props.pricingUpdate({ total: this.props.ordine.totale })
          // cosi' si salva lo state solo dopo che abbiamo aggiornato il totale con il valore in ordini
          this.props.storeDumpItForce()

          // BRUM-6303
          // si finanzia al massimo il piu' basso fra il massimo finanziabile e l'100% del prezzo totale
          // TODO controllare se questo e' superfluo ed e' backend che fa tutta la logica
          this.setState({
            importo_massimo_finanziabile:
              this.props.pricing.data.result.importo_massimo_finanziabile,
          })

          /**
           * BRUM-808 se sono costi extra nell'ordine
           * oppure i totali fra i finanziamenti ed il totale ordine
           * non risultano uguali
           * si ricalcolano i finanziamenti
           */
          if (
            json.result.costi_extra > 0 ||
            !totaleOrdineEqualTotaleFinanziamento(
              this.props.financements.default,
              this.props.ordine.totale
            )
          ) {
            const t = this
            let uri = ''
            let callback = null
            if (isFindomestic(t.props.product)) {
              uri = `${window.brumbrum.url_api}/findomestic/t/v1/calcolatrice/${t.props.ordine.id_ordine}`
              callback = t.props.newDefaultFinancementsFindomestic
            } else {
              uri = `${window.brumbrum.url_api}/compass/t/v1/calcolatrice/${t.props.ordine.id_ordine}/${t.props.product.id_auto}`
              callback = t.props.newDefaultFinancements
            }
            t.props
              .getDefaultFinancements({
                callback,
                uri,
                method: 'POST',
                token: t.props.customer.token,
                suppressOnlyErrorNotice: true,
              })
              .then(() => {
                t.props.setCompassCalcolatriceLogistica({
                  modal_new_rate_logistica: false,
                })
                t.setState({
                  hovered_calcolatrice: t.props.financements.default[0],
                })
                t.props.storeDumpItForce()
              })
              .catch(() => {
                t.setState({ modal: false })
              })
          } else {
            /**
             * BRUM-3519 PROCESSO D'ACQUISTO: finanziamenti cambiano con logistica
             * di default le teniamo hidden cosi' siamo sicuri che non lampeggiano
             */
            this.props.setCompassCalcolatriceLogistica({
              modal_new_rate_logistica: false,
            })
          }
        })
        .catch(() => null)
    }

    if (!this.state.isEECTracked) {
      this.setState(
        {
          isEECTracked: true,
        },
        () =>
          enhancedEcommerceTracker
            .pushCheckout(
              {
                product: this.props.product,
                ordine: this.props.ordine,
              },
              3
            )
            .then(() => {})
      )
    }
  }

  validate(label, value) {
    const v = verify(label, value, this.against_map(label))
    const new_state = {}

    if (v.is_required || !v.is_valid) {
      new_state[`${label}_error`] = v.is_required ? 'is-required' : 'is-error'
    } else {
      new_state[`${label}_error`] =
        label === 'presecci_sesso' ? 'genere' : ' is-ok'
    }

    this.setState(new_state)

    return v
  }

  against_map(label) {
    const t = this

    const against = {
      presecci_codice_fiscale: {
        nome: t.props.customer.nome || '',
        cognome: t.props.customer.cognome || '',
        sesso: t.props.customer.sesso || '',
        data_di_nascita: t.props.customer.data_di_nascita,
        paese_comune_di_nascita: t.props.customer.comune_nascita || '',
      },
      custom_calc_quota_da_finanziare: {
        importo_minimo_finanziabile:
          this.props.pricing.data.result.importo_minimo_finanziabile,
        importo_massimo_finanziabile:
          this.props.pricing.data.result.importo_massimo_finanziabile -
          this.props.ordine.acconti,
      },
    }

    return against[label]
  }

  handleInput(label, customCalcHandler = null) {
    const t = this
    return function (event) {
      const validate_label_prefix =
        customCalcHandler !== null ? 'custom_calc_' : 'presecci_'
      const v = t.validate(validate_label_prefix + label, event.target.value)
      const updateHandler =
        customCalcHandler !== null ? customCalcHandler : t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })
    }
  }

  handleSelect(label) {
    const t = this
    return function (selected) {
      const validate_label_prefix = 'dati_cliente_'
      const v = t.validate(
        validate_label_prefix + label,
        selected ? selected.value : ''
      )
      const updateHandler = t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })
    }
  }

  validate_presecci() {
    const t = this
    const validation_map = {
      presecci_nome: t.props.customer.nome || '',
      presecci_cognome: t.props.customer.cognome || '',
      presecci_comune_nascita: t.props.customer.comune_nascita || '',
      presecci_sesso: t.props.customer.sesso || '',
      presecci_codice_fiscale: t.props.customer.codice_fiscale || '',
      presecci_data_di_nascita: t.props.customer.data_di_nascita.raw || '',
    }

    const validation_results = Object.keys(validation_map).map(
      key => t.validate(key, validation_map[key]).is_valid
    )

    return validation_results.indexOf(false) === -1
  }

  validate_compass_custom_calc() {
    const t = this

    const validation_map = {
      custom_calc_quota_da_finanziare:
        t.props.financements.quota_da_finanziare || '',
      custom_calc_rata_mensile_desiderata:
        t.props.financements.rata_mensile_desiderata || '',
    }

    const validation_results = Object.keys(validation_map).map(
      key => t.validate(key, validation_map[key]).is_valid
    )

    return validation_results.indexOf(false) === -1
  }

  handleAcceptSecci() {
    if ('success' in this.props.secci && this.props.secci.success) {
      const t = this
      t.props.reroute().then(() => {
        t.props
          .acceptSecci({
            method: 'PUT',
            uri: `${window.brumbrum.url_api}/compass/t/v1/secci/${t.props.ordine.id_ordine}`,
            token: t.props.customer.token,
            callback: t.props.newSecci,
            body: JSON.stringify({
              secci_accettato: 1,
              id_secci: t.props.secci.id_secci,
            }),
          })
          .then(() => {
            t.handlePaymentMethod(PAYMENT_METHODS.FINANCING)()
          })
          .catch(() => {
            t.setState({ modal: false })
          })
      })
    }
  }

  handleModal(e) {
    this.setState({ modalFile: e.target.dataset.modal })
  }

  handleModificaRata() {
    this.setState({ id_finanziamento: null })

    this.props.updateSecci({
      percorso_aws: null,
    })

    this.props.updateOrdine({
      id_finanziamento: null,
    })

    animateScroll.scrollToTop()
  }

  handlePaymentMethod(method) {
    if (
      PAYMENT_METHODS.BANK === method &&
      this.state.bankTransferSettingsHelper.isBankTransferDisabled
    ) {
      return () => {}
    }

    const t = this
    return function () {
      t.props.paymentMethodSelected({
        method,
        reset: method !== t.props.payment.method,
      })
      t.props.phaseChange({
        last: t.props.ui.last > 20 ? t.props.ui.last : 20,
      })
      if (PAYMENT_METHODS.BANK === method) {
        t.props.postBonificoSelected({
          method: 'PUT',
          uri: `${window.brumbrum.url_api}/ordini/t/v1/ordini/${t.props.ordine.id_ordine}`,
          token: t.props.customer.token,
          id_finanziamento: null,
          body: JSON.stringify({
            id_finanziamento: null,
          }),
          callback: t.props.finanziamentoSelected,
        })

        enhancedEcommerceTracker
          .pushCheckoutOption(3, PAYMENT_METHODS.BANK_TRANSFER)
          .then(() => {})
        t.props.reroute('/dati')
      } else {
        enhancedEcommerceTracker
          .pushCheckoutOption(3, PAYMENT_METHODS.FINANCING)
          .then(() => {})
        t.props.reroute('/dati-finanziamento')
      }
    }
  }

  handleRichiediFinanziamento(id_finanziamento) {
    const t = this
    return function () {
      t.setState({ id_finanziamento })

      if (isFindomestic(t.props.product)) {
        // findomestic non ha il secci
      } else if (
        t.props.customer.id_cliente &&
        t.props.customer.tracciato_sent
      ) {
        // only in case of restore
        t.setState({ secci_loading: true })
      }

      t.props
        .postFinanziamentoSelected({
          method: 'PUT',
          uri: `${window.brumbrum.url_api}/ordini/t/v1/ordini/${t.props.ordine.id_ordine}`,
          token: t.props.customer.token,
          id_finanziamento,
          body: JSON.stringify({
            id_finanziamento,
          }),
          callback: t.props.finanziamentoSelected,
          error_400: 'auto_non_disponibile',
        })
        .then(() => {
          if (isFindomestic(t.props.product)) {
            t.handlePaymentMethod(PAYMENT_METHODS.FINDOMESTIC_FINANCING)()
          } else if (
            t.props.customer.id_cliente &&
            t.props.customer.tracciato_sent
          ) {
            t.postSecci()
          }
        })
        .catch(() => {
          t.setState({ id_finanziamento: null })
        })
    }
  }

  handlePreSecci() {
    const t = this
    if (this.validate_presecci()) {
      t.setState({ secci_loading: true })

      t.props
        .putClienti({
          cliente: {
            ...this.props.customer,
            id_tracciato: t.props.privacy.id_tracciato,
          },
          token: this.props.customer.token,
          id_ordine: this.props.ordine.id_ordine,
          callback: this.props.putClientiCallback,
          error_400: 'dati_non_corretti',
        })
        .then(() => {
          this.props.tracciatoSent()
          /**
           * faccio generare il pdf del secci
           */
          this.props.storeDumpItForce()
          this.postSecci()
        })
        .catch(() => {
          t.setState({ secci_loading: false })
        })
    }
  }

  postSecci() {
    const t = this
    this.props
      .postSecci({
        method: 'post',
        uri: `${window.brumbrum.url_api}/compass/t/v1/secci/${this.props.ordine.id_ordine}`,
        token: this.props.customer.token,
        callback: this.props.newSecci,
      })
      .then(() => {
        this.setState({ secci_loading: false })
      })
      .catch(() => {
        t.setState({ secci_loading: false })
      })
  }

  handleHoverRateBox(calcolatrice) {
    const t = this
    return function () {
      t.setState({ hovered_calcolatrice: calcolatrice })
    }
  }

  buildBankTransferBox() {
    return (
      !this.isOnlyQuotationMode && (
        <React.Fragment>
          <h5 className="section-title section-title--bank-transfer --reduced mt-30">
            Pagamento in unica soluzione
          </h5>
          <div className="rate-box-wrapper">
            <div
              className="rate-box last"
              style={this.state.bankTransferSettingsHelper.cardStyle}
            >
              <div className="tan_taeg">
                <span
                  className="rata"
                  dangerouslySetInnerHTML={{
                    __html:
                      this.state.bankTransferSettingsHelper.title ||
                      'Pagamento<br/>100% bonifico',
                  }}
                  style={this.state.bankTransferSettingsHelper.titleStyle}
                />
                <hr />
                <div className="info">
                  {this.state.bankTransferSettingsHelper.descriptionRaw ? (
                    <span
                      dangerouslySetInnerHTML={{
                        __html:
                          this.state.bankTransferSettingsHelper
                            .descriptionRendered,
                      }}
                      style={
                        this.state.bankTransferSettingsHelper.descriptionStyle
                      }
                    />
                  ) : (
                    <React.Fragment>
                      <span>
                        {this.props.ordine.acconti ? 'Totale ordine' : 'Totale'}
                        : {numeral(this.props.pricing.total).format('$ 0,0.00')}
                        <br />
                        {this.props.ordine.acconti
                          ? `Acconto pre-autorizzato: ${numeral(
                              this.props.ordine.acconti
                            ).format('$ 0,0.00')}`
                          : null}
                        <br />
                      </span>
                      <br />
                      <br />
                      {this.props.ordine.acconti
                        ? `Totale dovuto: ${numeral(
                            this.props.pricing.total - this.props.ordine.acconti
                          ).format('$ 0,0.00')}`
                        : null}
                      <br />
                    </React.Fragment>
                  )}
                </div>
              </div>
              <a
                className={`btn btn-primary x-small ${
                  this.state.bankTransferSettingsHelper.isBankTransferDisabled
                    ? 'btn-disabled'
                    : ''
                }`}
                data-cy="checkout-wiretransfer"
                onClick={this.handlePaymentMethod(PAYMENT_METHODS.BANK)}
              >
                <span>Prosegui</span>
              </a>
            </div>
          </div>
        </React.Fragment>
      )
    )
  }

  buildRateBoxes(calcolatrici = []) {
    const t = this
    return (
      <React.Fragment>
        {calcolatrici.map((p, i) => (
          <BuyRateBox
            acconti={t.props.ordine.acconti}
            brumbrum_loader_visible={t.props.logistica.modal_new_rate_logistica}
            calcolatrice={p}
            dataCy={`checkout-financing-${i}`}
            error={this.props.error}
            handleClick={t.handleRichiediFinanziamento}
            handleHover={t.handleHoverRateBox(p)}
            key={`buildRateBoxes_${i}`}
            keyy={p.id_finanziamento}
            label={i === 0 ? 'La più scelta' : null}
            numeroRate={p.numero_rate}
            selected={i === 0}
          />
        ))}

        {!this.props.logistica.modal_new_rate_logistica &&
        this.props.financements &&
        this.props.financements.default &&
        this.props.financements.default.length ? (
          <div className="custom_rate hidden-lg">
            <a
              className="btn btn-secondary"
              onClick={() => {
                this.setState({ customCalcMobile: true })
              }}
            >
              <strong>Personalizza la tua rata</strong>
            </a>
            <a
              className="close-calculator"
              onClick={() => {
                this.setState({ customCalcMobile: false })
              }}
              style={
                this.state.customCalcMobile
                  ? { display: 'block' }
                  : { display: 'none' }
              }
            >
              <strong>Chiudi</strong>
            </a>
          </div>
        ) : null}

        {this.state.customCalcMobile ? (
          <BuyCustomCalc
            handleDoCustomCalc={this.handleDoCustomCalc}
            inputOnChange={this.handleInput(
              'rata_mensile_desiderata',
              this.props.updateFinancements
            )}
            liRataMensileClassName={`${this.state.custom_calc_rata_mensile_desiderata_error} wide`}
            max={
              this.props.pricing.data.result.importo_massimo_finanziabile -
              this.props.ordine.acconti
            }
            min={this.props.pricing.data.result.importo_minimo_finanziabile}
            selectOnChange={this.handleInput(
              'quota_da_finanziare',
              this.props.updateFinancements
            )}
            selectQuotaDaFinanziareClassName={`${this.state.custom_calc_quota_da_finanziare_error} wide`}
          >
            {this.props.financements.custom ? (
              <BuyRateBox
                acconti={this.props.ordine.acconti}
                calcolatrice={this.props.financements.custom}
                error={this.props.error}
                handleClick={this.handleRichiediFinanziamento}
                handleHover={event => {
                  this.handleHoverRateBox(this.props.financements.custom)(event)
                }}
                keyy={this.props.financements.custom.id_finanziamento}
                label={null}
                numeroRate={this.props.financements.custom.numero_rate}
                selected={
                  this.state.hovered_calcolatrice
                    ? this.state.hovered_calcolatrice.id_finanziamento
                    : this.props.financements.custom.id_finanziamento
                }
              />
            ) : null}
          </BuyCustomCalc>
        ) : null}
      </React.Fragment>
    )
  }

  handleDoCustomCalc(e) {
    e.preventDefault()
    if (!this.props.fetching && this.validate_compass_custom_calc()) {
      const t = this
      t.setState({ loadingCustomCalc: true })
      let uri = `${window.brumbrum.url_api}/compass/t/v1/calcolatrice/custom/${this.props.ordine.id_ordine}`
      let callback = t.props.updateFinancementsCompassCustomCalc
      let body = {
        importo_rata: t.props.financements.rata_mensile_desiderata,
        importo: t.props.financements.quota_da_finanziare,
      }
      if (isFindomestic(t.props.product)) {
        uri = `${window.brumbrum.url_api}/findomestic/t/v1/calcolatriceCustom/${this.props.ordine.id_ordine}`
        callback = t.props.updateFinancementsFindomesticCustomCalc
        body = {
          rata_desiderata: t.props.financements.rata_mensile_desiderata,
          importo_finanziato: t.props.financements.quota_da_finanziare,
        }
      }
      this.props
        .postCompassCustomCalc({
          callback,
          uri,
          body: JSON.stringify(body),
          token: t.props.customer.token,
          method: 'POST',
          suppressOnlyErrorNotice: true,
        })
        .then(() => {
          t.setState({ hovered_calcolatrice: t.props.financements.custom })
          t.setState({ loadingCustomCalc: false })
        })
        .catch(() => {
          t.setState({ loadingCustomCalc: false })
        })
    }
  }

  buildErrorRateBoxes() {
    return Array(3)
      .fill(0)
      .map((_, i) => (
        <div className="rate-box-wrapper">
          <div className="rate-box" data-finanziamento="fin-1" key={i}>
            <div className="tan_taeg">
              <span className="rata">
                <span>Impossibile procedere con il finanziamento</span>
              </span>
              <hr />
              <div className="info">
                Il calcolo del finanziamento &eacute; andato in errore
              </div>
            </div>
          </div>
        </div>
      ))
  }

  render() {
    const selectedFinanz =
      this.state.hovered_calcolatrice || this.props.financements.default[0]

    return (
      <div
        className={
          isFindomestic(this.props.product) ? 'sellout-findomestic' : ''
        }
      >
        <section
          className={`relative process ${
            this.isOnlyQuotationMode ? 'mode--only-quotation' : ''
          }`}
        >
          {this.isOnlyQuotationMode ? (
            <div className="process__header hide-print">
              <h1 className="process__title hide-print">
                Finanziamento con rata personalizzata
              </h1>
            </div>
          ) : (
            <div className="process__header hide-print">
              <h1 className="process__title hide-print">
                Come preferisci pagare?
              </h1>
              <p className="process__intro hide-print">
                Puoi scegliere un finanziamento oppure effettuare un bonifico
                dell'intero importo.
              </p>
            </div>
          )}

          <div className={'messages warning'}>
            <div className={'container'}>
              <OrderRecoveryBanner />
            </div>
          </div>

          <div className="user-informations">
            <div className="container_small">
              <div className="helpguide"></div>

              <div className="select_payment">
                <div
                  className="select_payment_container"
                  style={{
                    minHeight: '271px',
                  }}
                >
                  <div>
                    {isFindomestic(this.props.product) ? (
                      <div id="findomestic-rate-box-wrapper">
                        {this.isOnlyQuotationMode ? (
                          <p>
                            Questa è l'opzione di finanziamento a te dedicata
                            per questa {this.props.product.marca}{' '}
                            {this.props.product.modello}. <br />
                            Per maggiori informazioni contatta il nostro
                            servizio clienti.
                          </p>
                        ) : (
                          <React.Fragment>
                            <p>
                              Puoi finanziare <b>fino al 100%</b> dell'importo
                              di questa {this.props.product.marca}{' '}
                              {this.props.product.modello}
                              <br />
                              Ecco le tre opzioni di finanziamento che
                              potrebbero interessarti.
                            </p>
                            <img
                              className="logo-findomestic"
                              src={`${filesBaseUrl}/asset_sito/logo-findomestic.png`}
                            />
                          </React.Fragment>
                        )}
                      </div>
                    ) : null}

                    {this.isOnlyQuotationMode ? (
                      <img
                        className="logo-findomestic logo-findomestic--centered"
                        src={`${filesBaseUrl}/asset_sito/logo-findomestic.png`}
                      />
                    ) : null}
                    <h5 className="mb-30 section-title --reduced">
                      Pagamento a rate
                    </h5>
                  </div>
                  <div id="findomestic-rate-box-container">
                    {!this.isOnlyQuotationMode ? (
                      this.props.financements &&
                      this.props.financements.default &&
                      this.props.financements.default.length ? (
                        <React.Fragment>
                          {this.buildRateBoxes(this.props.financements.default)}
                          {this.buildBankTransferBox()}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {this.buildErrorRateBoxes()}
                          {this.buildBankTransferBox()}
                        </React.Fragment>
                      )
                    ) : (
                      <React.Fragment>
                        {this.props.financements.custom ? (
                          <BuyRateBox
                            acconti={this.props.ordine.acconti}
                            calcolatrice={this.props.financements.custom}
                            error={this.props.error}
                            handleClick={this.handleRichiediFinanziamento}
                            handleHover={event => {
                              this.handleHoverRateBox(
                                this.props.financements.custom
                              )(event)
                            }}
                            keyy={
                              this.props.financements.custom.id_finanziamento
                            }
                            label={null}
                            numeroRate={
                              this.props.financements.custom.numero_rate
                            }
                            selected={
                              this.state.hovered_calcolatrice
                                ? this.state.hovered_calcolatrice
                                    .id_finanziamento
                                : this.props.financements.custom
                                    .id_finanziamento
                            }
                          />
                        ) : null}
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
              <div className="ffix"></div>
              {!this.props.logistica.modal_new_rate_logistica &&
              !this.isOnlyQuotationMode &&
              this.props.financements &&
              this.props.financements.default &&
              this.props.financements.default.length ? (
                <div className="custom_rate hidden-md">
                  <a
                    onClick={() => {
                      this.setState({ customCalc: true })
                    }}
                  >
                    <strong>Personalizza la tua rata</strong>
                  </a>
                  <a
                    className="close-calculator"
                    onClick={() => {
                      this.setState({ customCalc: false })
                    }}
                    style={
                      this.state.customCalc
                        ? { display: 'inline' }
                        : { display: 'none' }
                    }
                  >
                    <strong>Chiudi</strong>
                  </a>
                </div>
              ) : null}

              {this.state.customCalc ? (
                <BuyCustomCalc
                  handleDoCustomCalc={this.handleDoCustomCalc}
                  inputOnChange={this.handleInput(
                    'rata_mensile_desiderata',
                    this.props.updateFinancements
                  )}
                  liRataMensileClassName={`${this.state.custom_calc_rata_mensile_desiderata_error} wide`}
                  max={
                    this.props.pricing.data.result
                      .importo_massimo_finanziabile - this.props.ordine.acconti
                  }
                  min={
                    this.props.pricing.data.result.importo_minimo_finanziabile
                  }
                  selectOnChange={this.handleInput(
                    'quota_da_finanziare',
                    this.props.updateFinancements
                  )}
                  selectQuotaDaFinanziareClassName={`${this.state.custom_calc_quota_da_finanziare_error} wide`}
                >
                  {this.props.financements.custom ? (
                    <BuyRateBox
                      acconti={this.props.ordine.acconti}
                      calcolatrice={this.props.financements.custom}
                      error={this.props.error}
                      handleClick={this.handleRichiediFinanziamento}
                      handleHover={event => {
                        this.handleHoverRateBox(this.props.financements.custom)(
                          event
                        )
                      }}
                      keyy={this.props.financements.custom.id_finanziamento}
                      label={null}
                      numeroRate={this.props.financements.custom.numero_rate}
                      selected={
                        this.state.hovered_calcolatrice
                          ? this.state.hovered_calcolatrice.id_finanziamento
                          : this.props.financements.custom.id_finanziamento
                      }
                    />
                  ) : null}
                </BuyCustomCalc>
              ) : null}

              {!this.props.logistica.modal_new_rate_logistica &&
                !this.state.loadingFinancements && (
                  <div className={'legal_note cart'}>
                    <div className="accordion">
                      {isFindomestic(this.props.product) ? (
                        <FenancementDetailsFindomestic {...selectedFinanz} />
                      ) : (
                        <FenancementDetails {...selectedFinanz} />
                      )}
                    </div>
                  </div>
                )}
            </div>
          </div>
        </section>

        {this.state.id_finanziamento &&
          !this.props.secci.percorso_aws &&
          !this.state.secci_loading &&
          !isFindomestic(this.props.product) && (
            <div
              className="the-modal modalino modal small show"
              data-modal="pre-secci"
            >
              <div className="modal-content small">
                <div className="js-codice-fiscale">
                  <div className="modal-header">
                    <i
                      className="icon-close"
                      onClick={() => {
                        this.setState({ id_finanziamento: null })
                        this.props.updateOrdine({ id_finanziamento: null })
                        animateScroll.scrollToTop()
                      }}
                    ></i>
                    <h4>
                      Inserisci i tuoi dati per procedere con la richiesta di
                      finanziamento
                    </h4>
                  </div>

                  <div className="help-label top">
                    <span className="help-tip">
                      Assicurati che i dati corrispondano al futuro intestatario
                      dell'auto, residente in Italia e di età compresa tra i 18
                      e 70 anni
                    </span>
                  </div>

                  <form>
                    <ul className="data-form">
                      <li className={this.state.presecci_nome_error}>
                        <input
                          className="form-input big capitalize"
                          data-hj-suppress
                          defaultValue={
                            this.props.customer.nome || this.props.customer.name
                          }
                          onBlur={this.handleInput('nome')}
                          placeholder={'Scrivi il tuo Nome'}
                          type="text"
                        />
                        <label className="label">
                          Nome (completo di secondo nome)
                        </label>
                      </li>
                      <li className={this.state.presecci_cognome_error}>
                        <input
                          className="form-input big capitalize"
                          data-hj-suppress
                          defaultValue={
                            this.props.customer.cognome ||
                            this.props.customer.surname
                          }
                          onBlur={this.handleInput('cognome')}
                          placeholder={'Scrivi il tuo Cognome'}
                          type="text"
                        />
                        <label className="label">Cognome</label>
                      </li>
                      <li className={this.state.presecci_data_di_nascita_error}>
                        <BuyDateInput
                          classes="form-input big"
                          defaultValue={
                            this.props.customer.data_di_nascita.raw || ''
                          }
                          label={'Data di nascita (gg/mm/aaaa)'}
                          placeholder={'00/00/0000'}
                          type={'text'}
                          update={this.handleInput('data_di_nascita')}
                        />
                      </li>
                      <BuySelectInput2
                        defaultValue={this.props.customer.comune_nascita}
                        label={'Comune di nascita (o Stato estero)'}
                        liClassName={`${this.state.presecci_comune_nascita_error} `}
                        placeholder={'Seleziona il Comune'}
                        update={this.handleSelect('comune_nascita')}
                        values={this.props.comuni.comune.concat(
                          this.props.comuni.nazione
                        )}
                      />
                      <BuyRadioInput
                        defaultValue={this.props.customer.sesso}
                        label={'sesso '}
                        liClassName={this.state.presecci_sesso_error}
                        update={this.handleInput('sesso')}
                        values={[
                          { label: 'Femmina', value: 'F' },
                          { label: 'Maschio', value: 'M' },
                        ]}
                      />
                      <li className={this.state.presecci_codice_fiscale_error}>
                        <input
                          className="form-input big uppercase"
                          defaultValue={this.props.customer.codice_fiscale}
                          onBlur={this.handleInput('codice_fiscale')}
                          type="text"
                        />
                        <label className="label">Codice fiscale</label>
                      </li>
                      <li className="hr"></li>
                      <li className="wide buttons one_button">
                        <a
                          className="btn btn-secondary js-close-pre-secci"
                          onClick={this.handlePreSecci}
                        >
                          <span>Conferma i tuoi dati</span>
                        </a>
                      </li>
                    </ul>
                  </form>
                </div>
              </div>
            </div>
          )}

        {(this.state.secci_loading || this.props.secci.percorso_aws) && (
          <div className="modal-content secci_modal" style={{ zIndex: 9999 }}>
            {!this.props.secci.percorso_aws && (
              <div className="js-secci-loading">
                <i className="icon-spinner big"></i>
                <p>
                  Stiamo caricando il documento informativo precontrattuale per
                  la tua richiesta di finanziamento.
                </p>
              </div>
            )}

            {this.props.secci.percorso_aws && (
              <div className="js-secci">
                <div className="modal-header w-buttons">
                  <h4>
                    Informativa europea di base sul credito ai consumatori
                  </h4>
                  <div className="buttons_set f-right">
                    <button
                      className="btn btn-secondary x-small"
                      onClick={this.handleModificaRata}
                    >
                      <span>Modifica rata</span>
                    </button>
                  </div>
                </div>
                <div className="overflow">
                  <div className="terms secci_info">
                    <div id="secci_pdf" style={{ height: '100%' }}>
                      <PdfViewer url={this.props.secci.percorso_aws} />
                    </div>
                  </div>

                  <div className="modal-footer">
                    <div className="buttons_set center">
                      <a
                        className={`btn btn-primary big${
                          'success' in this.props.secci &&
                          this.props.secci.success
                            ? ''
                            : ' btn-disabled'
                        }`}
                        onClick={this.handleAcceptSecci}
                      >
                        <span>Accetta</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}

Checkout.propTypes = {
  ordine: PropTypes.object,
  product: PropTypes.object,
}

const mapStateToProps = state => ({
  error: state.error,
  pricing: state.pricing,
  financements: state.financements,
  customer: state.customer,
  ordine: state.ordine,
  secci: state.secci,
  product: state.product,
  fetching: state.ui.fetching,
  comuni: state.comuni,
  compass_tabelledominio: state.compass_tabelledominio,
  ui: state.ui,
  payment: state.payment,
  privacy: state.privacy,
  logistica: state.logistica,
})

export default connect(mapStateToProps, {
  phaseChange,
  customerUpdate,
  reroute,
  getDefaultFinancements,
  paymentMethodSelected,
  finanziamentoSelected,
  putClienti,
  postFinanziamentoSelected,
  postBonificoSelected,
  postCompassCustomCalc,
  updateFinancementsCompassCustomCalc,
  getFinancementDetails,
  updateFinancementsFindomesticCustomCalc,
  putClientiCallback,
  updateFinancements,
  postSecci,
  updateOrdine,
  getOrdine,
  newOrdine,
  pricingUpdate,
  updateSecci,
  acceptSecci,
  getComuni,
  newComuni,
  getNazioni,
  newNazioni,
  newSecci,
  storeDumpItForce,
  newDefaultFinancements,
  newDefaultFinancementsFindomestic,
  getTabelleDominioCompass,
  getTabelleDominioCompassCallbackCittadinanza,
  tracciatoSent,
  setCompassCalcolatriceLogistica,
})(Checkout)
